import { Table } from 'antd';
import React from 'react';

import { HISTORY_APPLICATIONS } from './constants';
import { getTableColumns } from './helpers';

export const HistoryTable = () => {
  const columns = getTableColumns();

  return (
    <Table
      bordered
      rowKey="_id"
      scroll={{ x: 'max-content' }}
      columns={columns}
      dataSource={HISTORY_APPLICATIONS}
    />
  );
};
